// Lógica pura del visor de evidencias (POD): navegación entre evidencias,
// posición del panel flotante (pineado) y tipos asignables. Sin React para
// poder probarla sin renderizar el componente.

// Índice siguiente/anterior con vuelta circular. dir: +1 | -1.
export const stepIndex = (length, index, dir) => {
  if (!length) return -1
  const base = index < 0 ? 0 : index
  return (base + dir + length) % length
}

// Limita la posición {x, y} del panel para que quede dentro del viewport,
// dejando visible al menos la cabecera (para poder seguir arrastrándolo).
export const clampPosition = (pos, size, viewport, margin = 8) => {
  const maxX = Math.max(margin, viewport.width - size.width - margin)
  const maxY = Math.max(margin, viewport.height - 48)
  return {
    x: Math.min(Math.max(margin, pos.x), maxX),
    y: Math.min(Math.max(margin, pos.y), maxY),
  }
}

// Posición inicial del panel flotante: esquina superior derecha.
export const defaultPosition = (size, viewport, margin = 16) => ({
  x: Math.max(margin, viewport.width - size.width - margin),
  y: 80,
})

// Tipos a los que puede cambiarse una evidencia: el actual, OTHER (repetible)
// y los tipos únicos que aún no existen en el servicio.
export const assignableTypes = (allTypes, multiType, currentType, existingTypes) =>
  allTypes.filter(
    (ty) => ty === currentType || ty === multiType || !existingTypes.includes(ty),
  )

// El tipo solo se puede cambiar con la evidencia pendiente (regla del backend).
export const canChangeType = (pod, canWrite, heldByMe) =>
  !!canWrite && !!heldByMe && (pod?.status || "").toUpperCase() === "PENDING"
